// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file call/call_errors.proto (package com.gem.vcs.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

/**
 * Describes the file call/call_errors.proto.
 */
export const file_call_call_errors: GenFile =
  /*@__PURE__*/
  fileDesc(
    'ChZjYWxsL2NhbGxfZXJyb3JzLnByb3RvEhRjb20uZ2VtLnZjcy5jb250cmFjdCKBAwoJQ2FsbEVycm9yGg8KDUNoYW5uZWxDbG9zZWQaFAoSQ2hhbm5lbERvZXNudEV4aXN0GiEKH0hhc05vUGVybWlzc2lvbnNGb3JBY3Rpb25PbkNhbGwaGQoXSGFzTm9QZXJtaXNzaW9uc0ZvckNhbGwaJAoiSGFzTm9QZXJtaXNzaW9uc1RvRmluaXNoQ2FsbEZvckFsbBoeChxQZXJtaXNzaW9uUmVxdWVzdEFscmVhZHlTZW50GhQKElVuYWNjZXB0YWJsZUFjdGlvbhobChlSZWNvcmRpbmdJc1N0YXJ0ZWRBbHJlYWR5Gh0KG0FjdHVhbFJlY29yZGluZ0lkSGFzQ2hhbmdlZBoaChhDYWxsUmVjb3JkaW5nRG9lc250RXhpc3QaHwodV2FpdGluZ1Jvb21SZXF1ZXN0RG9lc250RXhpc3QaHwodV2FpdGluZ1Jvb21SZXF1ZXN0V2FzUmVqZWN0ZWQaGQoXUGFydGljaXBhbnRMaW1pdFJlYWNoZWRCGAoUY29tLmdlbS52Y3MuY29udHJhY3RQAWIGcHJvdG8z'
  );

/**
 * @generated from message com.gem.vcs.contract.CallError
 */
export type CallError = Message<'com.gem.vcs.contract.CallError'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.
 * Use `create(CallErrorSchema)` to create a new message.
 */
export const CallErrorSchema: GenMessage<CallError> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0);

/**
 * @generated from message com.gem.vcs.contract.CallError.ChannelClosed
 */
export type CallError_ChannelClosed = Message<'com.gem.vcs.contract.CallError.ChannelClosed'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.ChannelClosed.
 * Use `create(CallError_ChannelClosedSchema)` to create a new message.
 */
export const CallError_ChannelClosedSchema: GenMessage<CallError_ChannelClosed> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 0);

/**
 * @generated from message com.gem.vcs.contract.CallError.ChannelDoesntExist
 */
export type CallError_ChannelDoesntExist =
  Message<'com.gem.vcs.contract.CallError.ChannelDoesntExist'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.ChannelDoesntExist.
 * Use `create(CallError_ChannelDoesntExistSchema)` to create a new message.
 */
export const CallError_ChannelDoesntExistSchema: GenMessage<CallError_ChannelDoesntExist> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 1);

/**
 * @generated from message com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall
 */
export type CallError_HasNoPermissionsForActionOnCall =
  Message<'com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.HasNoPermissionsForActionOnCall.
 * Use `create(CallError_HasNoPermissionsForActionOnCallSchema)` to create a new message.
 */
export const CallError_HasNoPermissionsForActionOnCallSchema: GenMessage<CallError_HasNoPermissionsForActionOnCall> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 2);

/**
 * @generated from message com.gem.vcs.contract.CallError.HasNoPermissionsForCall
 */
export type CallError_HasNoPermissionsForCall =
  Message<'com.gem.vcs.contract.CallError.HasNoPermissionsForCall'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.HasNoPermissionsForCall.
 * Use `create(CallError_HasNoPermissionsForCallSchema)` to create a new message.
 */
export const CallError_HasNoPermissionsForCallSchema: GenMessage<CallError_HasNoPermissionsForCall> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 3);

/**
 * @generated from message com.gem.vcs.contract.CallError.HasNoPermissionsToFinishCallForAll
 */
export type CallError_HasNoPermissionsToFinishCallForAll =
  Message<'com.gem.vcs.contract.CallError.HasNoPermissionsToFinishCallForAll'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.HasNoPermissionsToFinishCallForAll.
 * Use `create(CallError_HasNoPermissionsToFinishCallForAllSchema)` to create a new message.
 */
export const CallError_HasNoPermissionsToFinishCallForAllSchema: GenMessage<CallError_HasNoPermissionsToFinishCallForAll> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 4);

/**
 * @generated from message com.gem.vcs.contract.CallError.PermissionRequestAlreadySent
 */
export type CallError_PermissionRequestAlreadySent =
  Message<'com.gem.vcs.contract.CallError.PermissionRequestAlreadySent'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.PermissionRequestAlreadySent.
 * Use `create(CallError_PermissionRequestAlreadySentSchema)` to create a new message.
 */
export const CallError_PermissionRequestAlreadySentSchema: GenMessage<CallError_PermissionRequestAlreadySent> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 5);

/**
 * @generated from message com.gem.vcs.contract.CallError.UnacceptableAction
 */
export type CallError_UnacceptableAction =
  Message<'com.gem.vcs.contract.CallError.UnacceptableAction'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.UnacceptableAction.
 * Use `create(CallError_UnacceptableActionSchema)` to create a new message.
 */
export const CallError_UnacceptableActionSchema: GenMessage<CallError_UnacceptableAction> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 6);

/**
 * @generated from message com.gem.vcs.contract.CallError.RecordingIsStartedAlready
 */
export type CallError_RecordingIsStartedAlready =
  Message<'com.gem.vcs.contract.CallError.RecordingIsStartedAlready'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.RecordingIsStartedAlready.
 * Use `create(CallError_RecordingIsStartedAlreadySchema)` to create a new message.
 */
export const CallError_RecordingIsStartedAlreadySchema: GenMessage<CallError_RecordingIsStartedAlready> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 7);

/**
 * @generated from message com.gem.vcs.contract.CallError.ActualRecordingIdHasChanged
 */
export type CallError_ActualRecordingIdHasChanged =
  Message<'com.gem.vcs.contract.CallError.ActualRecordingIdHasChanged'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.ActualRecordingIdHasChanged.
 * Use `create(CallError_ActualRecordingIdHasChangedSchema)` to create a new message.
 */
export const CallError_ActualRecordingIdHasChangedSchema: GenMessage<CallError_ActualRecordingIdHasChanged> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 8);

/**
 * @generated from message com.gem.vcs.contract.CallError.CallRecordingDoesntExist
 */
export type CallError_CallRecordingDoesntExist =
  Message<'com.gem.vcs.contract.CallError.CallRecordingDoesntExist'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.CallRecordingDoesntExist.
 * Use `create(CallError_CallRecordingDoesntExistSchema)` to create a new message.
 */
export const CallError_CallRecordingDoesntExistSchema: GenMessage<CallError_CallRecordingDoesntExist> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 9);

/**
 * @generated from message com.gem.vcs.contract.CallError.WaitingRoomRequestDoesntExist
 */
export type CallError_WaitingRoomRequestDoesntExist =
  Message<'com.gem.vcs.contract.CallError.WaitingRoomRequestDoesntExist'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.WaitingRoomRequestDoesntExist.
 * Use `create(CallError_WaitingRoomRequestDoesntExistSchema)` to create a new message.
 */
export const CallError_WaitingRoomRequestDoesntExistSchema: GenMessage<CallError_WaitingRoomRequestDoesntExist> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 10);

/**
 * @generated from message com.gem.vcs.contract.CallError.WaitingRoomRequestWasRejected
 */
export type CallError_WaitingRoomRequestWasRejected =
  Message<'com.gem.vcs.contract.CallError.WaitingRoomRequestWasRejected'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.WaitingRoomRequestWasRejected.
 * Use `create(CallError_WaitingRoomRequestWasRejectedSchema)` to create a new message.
 */
export const CallError_WaitingRoomRequestWasRejectedSchema: GenMessage<CallError_WaitingRoomRequestWasRejected> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 11);

/**
 * @generated from message com.gem.vcs.contract.CallError.ParticipantLimitReached
 */
export type CallError_ParticipantLimitReached =
  Message<'com.gem.vcs.contract.CallError.ParticipantLimitReached'> & {};

/**
 * Describes the message com.gem.vcs.contract.CallError.ParticipantLimitReached.
 * Use `create(CallError_ParticipantLimitReachedSchema)` to create a new message.
 */
export const CallError_ParticipantLimitReachedSchema: GenMessage<CallError_ParticipantLimitReached> =
  /*@__PURE__*/
  messageDesc(file_call_call_errors, 0, 12);
